import React, { useEffect } from "react";
import css from "./Design.module.scss";
import SecOne from "./SecOne/SecOne";
import SecTwo from "./SecTwo/SecTwo";
import SecThree from "./SecThree/SecThree";
import SecFour from "./SecFour/SecFour";
import SecFive from "./SecFive/SecFive";
import { constants } from "assets/constants";
import { Helmet } from "react-helmet";

const Design = () => {
    return (
        <div className={css.design}>
            <Helmet>
                <title>{constants.titles.services_design}</title>
                <meta name="description" content={constants.descriptions.services_design} />
            </Helmet>
            <SecOne />
            <SecTwo />
            <SecThree />
            <SecFour />
            <SecFive />
        </div>
    );
};

export default Design;
